const themeConfig = {
  token: {
    colorPrimary: '#84bd00', // previous @primary-color
    colorText: '#000000', // previous @text-color
    colorBgLayout: '#ffffff', // previous @layout-body-background

    colorLink: '#84bd00',
    colorLinkHover: '#5a8700',
    colorLinkActive: '#3c5d00',
  },
  components: {
    Layout: {
      headerBg: '#f5f5f5', // previous @layout-header-background
    },
  },
};

export default themeConfig;
